import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-speed',
  templateUrl: './speed.component.html',
  styleUrls: ['./speed.component.scss'],
})
export class SpeedComponent implements OnInit {
  @ViewChildren('itemsContainer') elements!: QueryList<ElementRef>;
  items!: [{ title: string; value: number }];

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.items = this.translate.instant('home_speed.items');
  }

  ngAfterViewInit() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const item = this.items.find(
              (item) => item.title === entry.target.getAttribute('data-title')
            );
            (entry.target as HTMLElement).style.setProperty(
              '--value',
              item?.value.toString() ?? '0'
            );
          }
        });
      },
      { threshold: 1.0 }
    );

    this.elements.forEach((element) => {
      observer.observe(element.nativeElement);
    });
  }
}
